var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

const React = require('react');
const Icon = require('@infotech/uikit-icon').default;

function Svg(props) {
  const svgProps = Object.assign({}, props);
  const title = props.title;
  delete props.title;

  /* <svg {...svgProps} ><title>{title}<title>...</svg> */
  return React.createElement(
    'svg',
    _extends({ viewBox: '0 0 16 16', focusable: 'false' }, svgProps, { 'aria-labelledby': 'title' }),
    React.createElement(
      'title',
      { id: 'title' },
      title
    ),
    React.createElement('path', { d: 'M4.607 6h6.786c.335 0 .607.236.607.527 0 .14-.064.274-.178.373L8.43 9.846a.674.674 0 01-.86 0L4.179 6.9a.48.48 0 010-.746.657.657 0 01.43-.154z', fillRule: 'evenodd', role: 'presentation' })
  );
}

module.exports = function downFill(props) {
  return React.createElement(Icon, _extends({ glyph: Svg }, props));
};